import { Component, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/services/api/api.service";
import { map } from "rxjs/operators";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "app-terms-and-conditions",
  templateUrl: "./terms-and-conditions.component.html",
  styleUrls: ["./terms-and-conditions.component.scss"],
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
  private termsAndConditionsSubscription: Subscription;
  private termsAndConditions;

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    // temporary from admin
    this.termsAndConditionsSubscription = this.apiService
      .get("tac")
      .pipe(map((response) => response))
      .subscribe((response) => {
        this.termsAndConditions = response.data.terms_and_conditions;
      });
  }

  get getMessage() {
    return this.termsAndConditions;
  }

  ngOnDestroy() {
    if (this.termsAndConditionsSubscription) {
      this.termsAndConditionsSubscription.unsubscribe();
    }
  }
}
